export const getRandomColor = () => {
    let letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

export const getPreDefinedColor = (i) => {
  const colors = ['#3366CC', '#DC3912', '#FF9900', '#109618', '#990099', '#0099C6', '#DD4477'];
  return colors[i];
}

export const countFreq = (arr) => {
    var mp = new Map();
 
    // Traverse through array elements and
    // count frequencies
    for (var i = 0; i < arr.length; i++)
    {
        if(mp.has(arr[i]))
            mp.set(arr[i], mp.get(arr[i])+1)
        else
            mp.set(arr[i], 1)
    }
    
    return mp;
  }

export const calcMean = (arr) => {
  const total = arr.reduce((a,b) => a+b, 0);
  const mean = (total/arr.length);

  return mean;
}